import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/20/solid";
import { BenchmarkComparison } from "@/api/studio/library/types/benchmark.type";
import { cn } from "@/utils/classes";

/* Prop Types */
interface VideoBenchmarkPillProps {
  comparison: BenchmarkComparison;
}

/**
 * VideoBenchmarkPill component
 *
 * Shows whether a video's Attention score is below, within, or above the applied benchmark.
 */
export const VideoBenchmarkPill = ({ comparison }: VideoBenchmarkPillProps) => {
  /* Consts */
  const { status, deltaPercent } = comparison;

  /* Render */
  return (
    <div
      className={cn("flex items-center gap-1 justify-center px-1.5 py-0.5 rounded-lg text-xs font-semibold text-base-content w-fit", {
        "bg-[rgba(240,46,46,0.6)]": status === "below",
        "bg-[rgba(208,98,0,0.6)]": status === "within",
        "bg-[rgba(29,133,16,0.5)]": status === "above",
      })}
    >
      {status === "below" && <ChevronDownIcon className="size-3.5" />}
      {status === "above" && <ChevronUpIcon className="size-3.5" />}
      <span>{status === "within" ? "Within benchmark" : `${deltaPercent}% vs benchmark`}</span>
    </div>
  );
};
